import React from 'react';
import PersonAvatar from './PersonAvatar';

const ProfileImageField = ({
  value,
  onChange,
  onUpload,
  uploading = false,
  person = {},
}) => (
  <div className="profile-image-field">
    <div className="profile-image-field-preview">
      <PersonAvatar person={{ ...person, profile_image_url: value }} size="lg" />
      <div className="profile-image-field-actions">
        <label className="btn btn-secondary btn-sm profile-image-upload-btn">
          {uploading ? 'Uploading…' : 'Upload photo'}
          <input
            type="file"
            accept="image/*"
            disabled={uploading}
            onChange={onUpload}
            hidden
          />
        </label>
        {value ? (
          <button
            type="button"
            className="btn btn-danger btn-sm"
            onClick={() => onChange('')}
          >
            Remove
          </button>
        ) : null}
      </div>
    </div>
    <div className="form-group profile-image-url-field">
      <label htmlFor="profile-image-url">Image URL</label>
      <input
        id="profile-image-url"
        type="url"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="https://… or upload above"
      />
      <small className="field-hint">Optional. JPG or PNG, max 5 MB.</small>
    </div>
  </div>
);

export default ProfileImageField;
